"use strict";
/* eslint-disable react/prop-types */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PageExplorerMenuItemDefinition = exports.PageExplorerMenuItem = void 0;
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("../../Button/Button"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var LinkMenuItem_1 = require("./LinkMenuItem");
var react_redux_1 = require("react-redux");
var PageExplorer_1 = __importStar(require("../../PageExplorer"));
var actions_1 = require("../../PageExplorer/actions");
var SidebarPanel_1 = require("../SidebarPanel");
var Sidebar_1 = require("../Sidebar");
var PageExplorerMenuItem = function (_a) {
    var path = _a.path, item = _a.item, state = _a.state, dispatch = _a.dispatch, navigate = _a.navigate;
    var isOpen = state.navigationPath.startsWith(path);
    var isActive = isOpen || state.activePath.startsWith(path);
    var depth = path.split('.').length;
    var isInSubMenu = path.split('.').length > 2;
    var _b = __read(React.useState(false), 2), isVisible = _b[0], setIsVisible = _b[1];
    var store = React.useRef(null);
    if (!store.current) {
        store.current = PageExplorer_1.initPageExplorerStore();
    }
    React.useEffect(function () {
        if (isOpen) {
            // isOpen is set at the moment the user clicks the menu item
            setIsVisible(true);
            if (store.current) {
                store.current.dispatch(actions_1.openPageExplorer(item.startPageId));
            }
        }
        else if (!isOpen && isVisible) {
            // When a submenu is closed, we have to wait for the close animation
            // to finish before making it invisible
            setTimeout(function () {
                setIsVisible(false);
                if (store.current) {
                    store.current.dispatch(actions_1.closePageExplorer());
                }
            }, Sidebar_1.SIDEBAR_TRANSITION_DURATION);
        }
    }, [isOpen]);
    var onClick = function (e) {
        e.preventDefault();
        // Open/close explorer
        if (isOpen) {
            dispatch({
                type: 'set-navigation-path',
                path: '',
            });
        }
        else {
            dispatch({
                type: 'set-navigation-path',
                path: path,
            });
        }
    };
    var className = ('sidebar-menu-item'
        + (isActive ? ' sidebar-menu-item--active' : '')
        + (isInSubMenu ? ' sidebar-menu-item--in-sub-menu' : ''));
    var sidebarTriggerIconClassName = ('sidebar-sub-menu-trigger-icon'
        + (isOpen ? ' sidebar-sub-menu-trigger-icon--open' : ''));
    return (React.createElement("li", { className: className },
        React.createElement(Button_1["default"], { dialogTrigger: true, onClick: onClick, className: "sidebar-menu-item__link" },
            React.createElement(Icon_1["default"], { name: "folder-open-inverse", className: "icon--menuitem" }),
            React.createElement("span", { className: "menuitem-label" }, item.label),
            React.createElement(Icon_1["default"], { className: sidebarTriggerIconClassName, name: "arrow-right" })),
        React.createElement("div", null,
            React.createElement(SidebarPanel_1.SidebarPanel, { isVisible: isVisible, isOpen: isOpen, depth: depth, widthPx: 485 }, store.current &&
                React.createElement(react_redux_1.Provider, { store: store.current },
                    React.createElement(PageExplorer_1["default"], { isVisible: isVisible, navigate: navigate }))))));
};
exports.PageExplorerMenuItem = PageExplorerMenuItem;
var PageExplorerMenuItemDefinition = /** @class */ (function (_super) {
    __extends(PageExplorerMenuItemDefinition, _super);
    function PageExplorerMenuItemDefinition(_a, startPageId) {
        var name = _a.name, label = _a.label, url = _a.url, _b = _a.icon_name, iconName = _b === void 0 ? null : _b, _c = _a.classnames, classnames = _c === void 0 ? undefined : _c;
        var _this = _super.call(this, { name: name, label: label, url: url, icon_name: iconName, classnames: classnames }) || this;
        _this.startPageId = startPageId;
        return _this;
    }
    PageExplorerMenuItemDefinition.prototype.render = function (_a) {
        var path = _a.path, state = _a.state, dispatch = _a.dispatch, navigate = _a.navigate;
        return (React.createElement(exports.PageExplorerMenuItem, { key: this.name, item: this, path: path, state: state, dispatch: dispatch, navigate: navigate }));
    };
    return PageExplorerMenuItemDefinition;
}(LinkMenuItem_1.LinkMenuItemDefinition));
exports.PageExplorerMenuItemDefinition = PageExplorerMenuItemDefinition;
